import React from 'react';
import PropTypes from 'prop-types';

const Filter = (props) => {
  return (
    <span className={`sb-filter-item sb-filter-item-${props.value} ${props.handleChecked ? 'sb-filter-item-selected' : ''}`}>
      <label htmlFor={`${props.filter.type}-${props.value}`} title={props.label}>
        <input
          aria-controls="locations-list, Google-Map-Container"
          type={props.filter.type}
          name={props.filter.filter}
          value={props.value}
          checked={props.handleChecked}
          onChange={props.handleOnChange}
          id={`${props.filter.type}-${props.value}`} />
        <span>{props.label}</span>
      </label>
    </span>
  );
};

Filter.propTypes = {
  filter: PropTypes.object,
  handleChecked: PropTypes.bool,
  handleOnChange: PropTypes.func,
  label: PropTypes.string,
  value: PropTypes.string,
};

export default Filter;
